import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../../styles/login.css';

const InputField = ({ label,name,type='text',value }) => {
  return(
    <input type={type} name={name} value={value} id={name} placeholder={label} className='outline-none border border-slate-200 py-1 px-3 rounded-lg focus:border-slate-900 placeholder:capitalize placeholder:text-slate-500' required autoComplete='off' />
  )
}
const AuthButton = ({ label,type='button' }) => {
  return(
    <input type={type} value={label} className='outline-none border-none py-1 mt-4 capitalize bg-blue-500 hover:bg-blue-600 hover:scale-95 text-white rounded' />
  )
}
const Login = ({ auth,updateAuth }) => {
  const initialData = {
    name:"",
    password:""
  }
  const [formData, setFormData] = useState(initialData);
  
  const navigate = useNavigate();

  useEffect(() => {
    if(auth) return navigate('/');
  },[auth]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
     if (formData.name.trim().length !== 0 && formData.name.trim().length) {
      if (formData.name.trim() === process.env.REACT_APP_ADMIN_NAME && formData.password.trim() === process.env.REACT_APP_ADMIN_PASSWORD) {
        alert('Login successful');
        updateAuth(true);
      }else{
        alert('Invalid credentials');
      }
     }else{
      alert('Fill all the fields');
     }
    } catch (err) {
      console.log(`An error occurred in login user:${err}`);
    }
  }

  const handleUserInput = (e) => {
    const { name,value } = e.target;
    setFormData(prev => ({...prev,[name]:value}));
  }

  const handleEnter = (e) => { 
    if (e.key.toLowerCase() === 'enter') {
      handleLogin(e);
    }
  }

        return (
           <div className='signup_frame'>
            <form className='flex flex-col gap-2 p-4 rounded-md shadow sm:w-80 w-72' method='POST' onSubmit={handleLogin} onChange={handleUserInput} onKeyDown={handleEnter}>
              <h2 className='font-bold text-3xl text-blue-500 capitalize text-center mb-1'>"Welcome back😀"</h2>
              <InputField name={'name'} label={'username'} value={formData.name}  />
              <InputField type={'password'} name={'password'} label={'password'} value={formData.password}  />
              <AuthButton type={'submit'} label={'login'} />
            </form>
           </div>
        )
    }

export default Login;